import * as React from "react";
import styled from "styled-components";
import { Alert, Button, Space } from "antd";
//import useRtm from "@/hooks/use-rtm";
import {useRTM} from "@/component/Rtm";
import { storage } from "@/util";
import { LOGININFOSTORE, METTINGPAGE_SAVED_MEETING_INFO, LOGINTOKEN, NORMALSETTINGKEY } from "@/config/const";
import { conference } from "@/api";
import { ConferenceInterface,UserInfo,BoolType,ConfefenctType, AnyType } from "@/types";
import { useHistory } from "react-router-dom";
import { message as antMsg } from "antd";
import { log } from "console";
import isElectron from "is-electron";
import { time } from "@/util";
import moment from "moment";
 
import { useAuth } from "@/component/Auth";
const Container = styled.div`
  position: fixed;
  left: calc(100wh - 250px);
  top: 40%;
  z-index: 99999999;
`;

const MessageNotify: React.FunctionComponent = () => {
  const auth = useAuth();
  const loginfo: UserInfo = auth.loginfo as UserInfo;
  const { userId } = loginfo;
  const history = useHistory();
 const {
  isRTMConnected, 
  rtmPublishToPeer,
  rtmPublish,
  addEventListener, 
  removeEventListener} = useRTM();
  const timerRef = React.useRef<NodeJS.Timeout>(null);
  const [joinConfNo, setjoinConfNo] = React.useState("");

  const [multi, setMulti] = React.useState(false);

  // if(userId.)
  React.useEffect(() => {
    if(isRTMConnected){
    addEventListener("message", messageHandler);
    }
    return () => {
      removeEventListener("message", messageHandler);
    };
  }, [isRTMConnected]);

  const [inviter, setInviter] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);

  const timerFunc = () => {
    timerRef.current = null;
    setInviter("");
    setShowAlert(false);
  };

  const messageHandler = (evt: any) => {
    const {
      channelName = "", //:  "notification"
      channelType = "", //:  "MESSAGE"
      message = "{}",
      //"{\"action\":\"call\",\"participants\":[\"btbodcdkraakkhf\"],\"room\":\"8608804819\",\"data\":{\"video\":{\"code\":\"H264\",\"resolution\":\"1024X768\"},\"audio\":{\"sampleRate\":\"44100\",\"channels\":2}}}"
      publisher = "",
    } = evt;

    const messageObj = JSON.parse(message);

    if(channelName != ""){
      //组呼
      setMulti(true);
      const saveduserId = storage.get(LOGININFOSTORE)?.userId ?? "";
      if (!saveduserId) return;
      const findedItem = messageObj.participants.find(
        (x: string) => x === saveduserId
      );
      if (!findedItem) return;
      //// 符合条件的
      setInviter(publisher);
      setShowAlert(true);
      setjoinConfNo(messageObj.room);

    }else{
      //单呼
      setMulti(false);
      const { action, room, result } = messageObj;
      // 对方接受，进入会议
      if (action === "call") {
        setInviter(publisher);
        setShowAlert(true);
        setjoinConfNo(messageObj.room);
        timerRef.current = setTimeout(timerFunc, 15000);
      } else if (action === "response") {
        if (result === "accept") {
          antMsg.warn("邀请已被接收");
          console.log("对方接受邀请，自己进会");
          //join(room);
          createNewMeeting();
        } else {
          antMsg.warn("邀请已被拒绝");

          //
        }
      }
    }

    // const messageObj = JSON.parse(message);
    
    // // 多人聊天模式
    // if (
    //   channelName.toLowerCase() === "notification" &&
    //   channelType.toLowerCase() === "message"
    // ) {
    //   setMulti(true);
    //   const saveduserId = storage.get(LOGININFOSTORE)?.userId ?? "";
    //   if (!saveduserId) return;
    //   const findedItem = messageObj.participants.find(
    //     (x: string) => x === saveduserId
    //   );
    //   if (!findedItem) return;
    //   //// 符合条件的
    //   setInviter(publisher);
    //   setShowAlert(true);
    //   setjoinConfNo(messageObj.room);
    //   /// 下面单人信息
    // } else if (channelType.toLowerCase() === "message") {
    //   setMulti(false);
    //   const { action, room, result } = messageObj;
    //   // 对方接受，进入会议
    //   if (action === "call") {
    //     setInviter(publisher);
    //     setShowAlert(true);
    //     setjoinConfNo(messageObj.room);
    //     timerRef.current = setTimeout(timerFunc, 15000);
    //   } else if (action === "response") {
    //     if (result === "accept") {
    //       antMsg.warn("邀请已被接收");
    //       console.log("对方接受邀请，自己进会");
    //       join(room);
    //     } else {
    //       antMsg.warn("邀请已被拒绝");

    //       //
    //     }
    //   }
    // }
    ///
  };
  

  const accept = (b: boolean) => {
    
    timerFunc();
    if (!multi) {
      console.log("发送接受请求");
      rtmPublishToPeer(
        inviter,
        JSON.stringify({
          action: "response",
          result: b ? "accept" : "decline",
          room: joinConfNo,
        })
      );
    }
    if (b) console.log("自己接受，自己进会");
    if (b) join();
  };

  const adescription = React.useMemo(
    () => `${inviter}邀请您加入会议，接受或者拒绝，15秒自动拒绝`,
    [inviter]
  );

  const createNewMeeting = async () => {
    const loginfo = storage.get(LOGININFOSTORE);
    const ret: any = await conference.conferenceCreate({
      title: `${loginfo.username || loginfo.realName}的会议`,
      beginTime: time.format(moment()),
      endTime: time.format(moment()),
      allowEarlyEntry: 1,
      muteJoinMeeting: 1,
      playTips: 0,
      allowSelfUnmute: 1,
      passwordEnable: 0,
      useSelfConference: 1,
      type: ConfefenctType.immediate,
      conferenceNo: loginfo.conferenceNo,
    });
    join(ret.conferenceNo);
  };

  // const joinMeeting = async (conferenceNo: string) => {
     
  //   const loginfo = storage.get(LOGININFOSTORE);
  //   const ret = await conference.conferenceJoin(
  //     {
  //       userName: loginfo.username,
  //       conferenceNo,
  //     },
  //     {
  //       "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
  //       "X-Device": "1", //	8
  //     }
  //   );
  //   const con = ret.conference as ConferenceInterface;
  //   con["X-Channel-Token"] = ret["X-Channel-Token"];
  //   con["X-Conference-Token"] = ret["X-Conference-Token"];
  //     // 此处赋予主持人角色
  //   con.roleCode = ret.roleCode;
  //   con.roleName = ret.roleName;

  //   if(con.roleCode === 20){
  //     con.roleName = ret.roleName;
  //     //  con.roleName = "主持人";
  //     con.currHostUserId = con.userId
  //   }
  //   con.roomid = ret.roomid;
   

  //   con.userId = ret.userid;
  //   console.log("joinMeeting result:::", JSON.stringify(con)  );
  //   goMeeting(con);
  // };

  // const goMeeting = async (conf: ConferenceInterface) => {
  //   const loginfo = storage.get(LOGININFOSTORE);
  //   const settings = (storage.get(NORMALSETTINGKEY) || {}) as AnyType;
  //   storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
  //   const url = `/meeting/${conf.roomId}?username=${
  //     loginfo.realName
  //   }&audio=${!!settings.mic}&video=${!!settings.video}&speaker=${!!settings.audio}`;
  //   history.push(url);
  // };

  //// 加入别人的会议
  const join = async (confNum?: string) => {
    const userName = storage.get(LOGININFOSTORE)?.realName ?? "user";
    const con: any = await getConferenceInfo(confNum ?? joinConfNo, userName);
    goMetting(con, userName);
  };

  const getConferenceInfo = async (
    conferenceNo: string,
    userName: string,
    password?: string
  ) => {
    try {
       
      const ret = await conference.conferenceJoin(
        {
          conferenceNo,
          userName,
          password,
        },
        {
          "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
          "X-Device": "1", //	8
        }
      );
      //需要先判断ret的code是200还是600xxx
      console.log(`[JoinMeeting] ret=${JSON.stringify(ret)}`);
      const con = ret.conference as ConferenceInterface;
      con.attendList = ret.attendList;
      con["X-Channel-Token"] = ret["X-Channel-Token"];
      con["X-Conference-Token"] = ret["X-Conference-Token"];
      con.roleCode = ret.roleCode;
      con.roomid = ret.roomid;
      con.roleName = ret.roleName;
      con.userId = ret.userid;
      return con;
    } catch (e) {
      return e;
    }
  };

  const goMetting = async (conf: ConferenceInterface, userName: string) => {
    storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
    const url = `#/meeting/${conf.roomId}?username=${userName}&audio=true&video=true&speaker=true`;
    window.location.href = url;
  };

  return (
    <Container>
      {showAlert && (
        <Alert
          message="会议邀请"
          description={adescription}
          type="info"
          action={
            <Space direction="vertical">
              <Button size="small" type="primary" onClick={() => accept(true)}>
                接受
              </Button>
              <Button size="small" danger ghost onClick={() => accept(false)}>
                拒绝
              </Button>
            </Space>
          }
        />
      )}
    </Container>
  );
};

export default MessageNotify;
